export const FETCH_SURCHARGE_CHECK_RESULT = 'FETCH_SURCHARGE_CHECK_RESULT';
export const CLEAR_SURCHARGE_CHECK_RESULT = 'CLEAR_SURCHARGE_CHECK_RESULT';
